import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, Optional, Inject, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
// import { MatDialog, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackBarComponent } from 'dhwani-material-library';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonFunctionService } from 'dhwani-material-library';
// import { MatRadioChange } from '@angular/material';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDragHandle,
  CDK_DRAG_CONFIG,
  CdkDragEnd,
} from "@angular/cdk/drag-drop";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TempModuleService } from '../../form-translate/services/temp-module.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers:[TempModuleService]
})
export class FileUploadComponent implements OnInit, OnChanges {
  @ViewChild('fileDropRef') fileDropRef: any;
  @Input() parentForm: FormGroup;
  fileUploadId: any;
  // public files: File[] = [];
  files: any = [];
  @Input() fileList: File[] = []
  @Output() afterSelectionMethod: EventEmitter<any> = new EventEmitter<any>();
  selectedUrl: string = ''
  imageUrl: any = [];
  mimeType: string = '';
  uploadOptions = [
    {name: 'Upload Files', value: 'file', checked: true},
    {name: 'Upload File URL', value: 'url', checked: false}
  ];
  tabs: any = ['Upload Files', 'Upload Urls']
  dataFileUpload:any = [{url: '', label:''}];
  selectedTab = 0;
  mediaValidation = [];
  zIndexSerial: number = 1000;
  urlPlaceHolder: string = 'Please enter url';
  labelPlaceHolder: string = 'Please enter label';
  isDisabled: boolean = false;
  tempFileArray: any =[];
  localArray: any =[];
  dataFileUploadTemp: any = [];
  isFileArray: any =[];
  constructor(
    public dialogRef: MatDialogRef<FileUploadComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private modalRef: MatDialogRef<any>,
    private surveyBuilderService: TempModuleService,
    private commonService: CommonFunctionService,
  ) {
    console.log('data', this.data);
    if(!this.data.hasOwnProperty('mediaType'))
    this.data.mediaType = 'image'
    if(this.data.dataFileUpload){
      this.dataFileUploadTemp = []
      this.dataFileUpload = JSON.parse(JSON.stringify(this.data.dataFileUpload))
      this.dataFileUploadTemp  =  JSON.parse(JSON.stringify(this.data.dataFileUpload))
    this.dataFileUploadTemp = this.dataFileUploadTemp.filter(item => item.label && item.url)
      console.log(this.dataFileUploadTemp)
      this.imageUrl = this.data.dataFileUpload.map(item=>item.url)
      if(this.data.mediaType == 'image')
      this.mimeType = 'image'
      this.mediaValidation = this.data.mediaValidation;
      if(this.data.placeHolder){
      this.urlPlaceHolder = this.data.placeHolder.mediaPlaceHolder;
      this.labelPlaceHolder = this.data.placeHolder.placeHolder;
      }
    }
  }

  ngOnInit() {
    console.log("dialogRef",this.dialogRef.componentInstance.data.placeHolder)
    console.log("dialogRef",this.dialogRef.componentInstance.data.placeHolder.id)
    if(this.dialogRef.componentInstance.data.placeHolder.id == 50.4){
      var index = this.tabs .indexOf('Upload Files');
      if (index > -1) {
          this.tabs.splice(index, 1);
      }
      this.selectedTab = 1;
      // this.addMultipleImage(1)
      this.dataFileUpload.push({label:'', url:''})

    }
    // tabs: any = ['Upload Files', 'Upload Urls']
    // dataFileUpload:any = [{url: '', label:''}];
    // selectedTab = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("filechanges", changes)
    // if (changes.fileList && changes.fileList && changes.fileList.currentValue) {
    //   this.mimeType = ""
    //   this.fileList = changes.fileList.currentValue;
    //   this.imageUrl = changes.fileList.currentValue.length && changes.fileList.currentValue[0].url;
    //   let mimeType = changes.fileList.currentValue[0].length && changes.fileList.currentValue[0].hasOwnProperty('type') ? changes.fileList.currentValue[0].type : changes.fileList.currentValue[0].mime;
    //   if (mimeType.match(/image\/*/) != null) {
    //     this.mimeType = "image"
    //   }
    // }
  }
  copyText(val) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.openSnackBar(['Content Copied...'], 3000);
}
  selectFile() {
    document.getElementById('filedrag').click();
  }

  onFilesChange(f) {
    console.log("files", f, this.files)
    console.log("this.fileList", this.fileList)
    this.dataFileUpload = []
    if (f.length) {
      this.isDisabled = true;
      this.fileList.push(...f);
      for(let item in this.fileList){
        // if(item <= this.fileList.length){   }
            this.uploadImage(this.fileList, item);
            this.preview(this.fileList, item);
      }
      console.log(this.fileList)
      this.surveyBuilderService.afterMethodFileSelect.next(f);
      this.files = f;
    }
    // this.fileDropRef.nativeElement.value = '';
  }

  deleteFile(index,data) {
    console.log(data.name)
    console.log(index)
    let arr =[]
    arr = this.fileList
    this.fileList = []
    this.files =[]
    console.log(typeof(this.fileList))
    console.log(this.fileList)
    console.log(this.fileList.length)
    let arrLength = arr.length
   for (let i = 0; i < arrLength; i++) {
     if(i != index){
       this.fileList.push(arr[i])
     }
   }
  //  this.addMultipleImage(index)

   let getIndex = this.dataFileUpload.findIndex(rank => rank.label.toString() === data.name.toString());
   console.log("getIndex",getIndex)
   if(getIndex > -1){
    this.dataFileUpload.splice(getIndex, 1)
  }
  console.log("???", this.dataFileUpload)

   this.files =  this.fileList
        // delete this.fileList[index]
     this.afterSelectionMethod.emit(this.files)
     this.snackBar.open("File was deleted!", null, {
          duration: 2000
        });
    console.log("-------",this.fileList)
  
  }

  check() {
    return this.parentForm.get("uploadFormId").value;
  }

  preview(files, i) {
    this.mimeType = ''
    if (files.length === 0)
      return;

    var mimeType = files[i].hasOwnProperty('type') ? files[i].type : files[i].mime;
    if (mimeType && mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    // this.imageUrl = files;
    console.log("readIles", files, i, files[i], files[0])
    reader.readAsDataURL(files[i]);
    reader.onload = (_event) => {
      this.mimeType = 'image';
      this.imageUrl[i] = reader.result;
    }
  }

  getFileExtension(file) {
    let type = '';
    if (file.hasOwnProperty('type') || file.type) {
      type = file.type
    } else {
      type = file.mime
    }
    // console.log("type", type, file)
    if(type)
    return this.commonService.getFileExtension(type);
  }

  uploadImage(files, index) {
    // this.openSnackBar(['Updating Form Icon..'], 5000);
    console.log("files, upload",files)
    console.log("files, upload index",index)
    let isDisableSeq = false;
    this.snackBar.open(`Uploading Image...`);
    let image = {
      type: files[index].type,
      name: files[index].name,
      file: files[index],
    };
    if(index == files.length -1)
    isDisableSeq = true
    this.setDocuments(image, isDisableSeq);

  }

  addMultipleImage(deleteIndex = -1){
    let multipleImage = this.dataFileUpload
    if(deleteIndex > -1){
      this.dataFileUpload.splice(deleteIndex, 1)
    }else{
      this.dataFileUpload.push({label:'', url:''})
    }
    
    // this.multipleImageForm.next([...multipleImage])
}
removeDuplicates(arr, equals) {
  var originalArr = arr.slice(0);
  var i, len, val;
  arr.length = 0;

  for (i = 0, len = originalArr.length; i < len; ++i) {
      val = originalArr[i];
      if (!arr.some(function(item) { return equals(item, val); })) {
          arr.push(val);
      }
  }
}

thingsEqual(thing1, thing2) {
  return thing1.url === thing2.url
      // && thing1.label === thing2.label;
}
  async setDocuments(imgObject, isDisableSeq = false) {
    console.log("??",this.dataFileUploadTemp)
    this.isFileArray.push(imgObject)
    console.log("imgObject",this.isFileArray.length)
    try {
      console.log(this.dataFileUpload)
      this.snackBar.open("Please Wait file is being uploaded to server !!!", null);
      let response = await this.surveyBuilderService.uploadTos3(
        imgObject.name, imgObject.type
      );
      if (response['success']) {
        this.selectedUrl = response['data'][0]['file_url'];
        this.afterSelectionMethod.emit({ url: this.selectedUrl, name: imgObject.name, mime: imgObject.type })
        this.dataFileUpload.push({ url: this.selectedUrl, label: imgObject.name, type: imgObject.type })
          if(this.dataFileUploadTemp && this.dataFileUploadTemp.length){
            this.dataFileUpload = this.dataFileUpload.concat(this.dataFileUploadTemp)
          }
          this.removeDuplicates(this.dataFileUpload , this.thingsEqual);
          console.log(this.dataFileUpload)
          console.log(">>>>>>>>>>>>>>",this.dataFileUpload.length)
        if(this.data.mediaType != 'image')
        this.imageUrl = this.dataFileUpload.map(item => item.url)
        try {
          let imageResponse = await this.surveyBuilderService.getImageUrl(
            response['data'][0]['url'],
            imgObject.file
          );
          this.selectedUrl = response['data'][0]['file_url'];
          console.log("ffff", this.selectedUrl, imgObject)
          if(isDisableSeq){
            if(this.dataFileUpload.length <= this.isFileArray.length){
              this.snackBar.dismiss();
            }
          }
          // this.isDisabled = false;
          
        } catch (e) {
          if(isDisableSeq)
          // this.isDisabled = false;
          this.openSnackBar(['Unable to save image'], 3000);
          console.error(e);
        }
      }
    } catch (e) {
      if(isDisableSeq)
          // this.isDisabled = false;
      this.openSnackBar(['Unable to save image'], 3000);
    }
  }

  openSnackBar(data: string[], duration) {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }

  closeLockDialog() {
    // this.fileDropRef.nativeElement.value = '';
    this.dialogRef.close({ event: 'close' });
  }

  submitUpload() {
    // let arrLength = this.fileList.length
    // for (let i = 0; i < arrLength; i++) {
    //   for(let item in this.fileList){
    //     if(item <= this.fileList.length){
    //   this.uploadImage(this.fileList, item);
    //   this.preview(this.fileList, item);
    //     }
    //   }
    // }
    console.log("?????",this.data)
    console.log('submitUpload', this.fileList, this.files, this.imageUrl);
    console.log('dataFileUpload', this.dataFileUpload);
    if(this.dialogRef.componentInstance.data.placeHolder.id != 50.4){
      if(this.dataFileUpload.some(item => !this.mediaValidation.includes(item.url.split('.').pop()))){
        this.openSnackBar([`Please enter ${this.data.mediaType} type file!!!`], 3000);
        return true;
      }
    }
    
    
    console.log('submitUpload', this.fileList, this.files, this.imageUrl);
    this.dataFileUpload = this.dataFileUpload.filter(item => item.label && item.url)
    if (this.data.multipleSelect == false) {
      this.dialogRef.close({ event: 'close', data: this.files[0] });
      // this.fileDropRef.nativeElement.value = '';
    } else {
      this.dialogRef.close({ event: 'close', data: this.files, file: this.dataFileUpload });
      // this.fileDropRef.nativeElement.value = '';
    }
    // this.dialogRef.close({ event: 'close', data: 'data' });
  }

  changeTab(event) {
    console.log("event", event)
    this.selectedTab = event;
    console.log("event", this.selectedTab)
  }

  /**
 * format bytes
 * @param bytes (File size in bytes)
 * @param decimals (Decimals point)
 */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadTypeChange($event: MatRadioChange) {
    console.log($event.source.name, $event.value);
}

dropTable(event: CdkDragDrop<any[]>) {
  console.log("dragg", event);
  // const prevIndex = this.editableIndicatorConditions.findIndex((d) => d === event.item.data);
  moveItemInArray(
    this.dataFileUpload,
    event.previousIndex,
    event.currentIndex
  );
  console.log("after", this.dataFileUpload);
  // this.table.renderRows();
}

onDragStarted(event: CdkDragEnd): void {
  event.source.element.nativeElement.style.zIndex=this.zIndexSerial+"";
  this.zIndexSerial = this.zIndexSerial+1;
}
}
